import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
} from 'reactstrap';
import _isNull from 'lodash/isNull';

import TitleText from './ReportIssueModal.style';

export default function ReportIssueModal({
  hideReportDialog,
  reportIssueData,
  reportIssue,
  test,
}) {
  const data = reportIssueData || {};
  const { problemSlug, problemName } = data;
  const { slug } = test;

  const showModal = !_isNull(reportIssueData);
  const [comment, setComment] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!showModal) setComment('');
  }, [showModal]);

  const onClose = () => {
    hideReportDialog();
  };

  const onReportIssue = () => {
    if (!comment || comment.length < 15 || comment.length > 1000) {
      setError(true);
      return;
    }
    reportIssue({
      comment,
      problem_slug: problemSlug,
      test_slug: slug,
      category: 'content',
    });
    hideReportDialog();
  };

  const onChange = ({ target }) => {
    setComment(target.value ? target.value : '');
    setError(!target.value);
  };

  return (
    <Modal
      backdrop="static"
      keyboard
      centered
      size="lg"
      isOpen={showModal}
      toggle={onClose}
    >
      <ModalHeader toggle={onClose}>
        <TitleText>
          Report an issue with <strong>{problemName}</strong>
        </TitleText>
      </ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label htmlFor="report_issue_comments">
            Briefly describe what is the issue with this question
          </Label>
          <textarea
            className={`form-control ${error ? 'is-invalid' : ''}`}
            onChange={onChange}
            placeholder="Comments"
            value={comment}
            id="report_issue_comments"
            rows="2"
          />
          <div className="invalid-feedback">
            Comments should contain at least 15 characters and at most 1000
            characters.
          </div>
          {!error && (
            <small className="form-text text-muted text-right">
              {comment.length}/1000
            </small>
          )}
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <button
          type="button"
          onClick={onClose}
          className="btn btn-outline-primary"
        >
          CANCEL
        </button>
        <button
          type="button"
          onClick={onReportIssue}
          className="btn btn-primary"
        >
          SUBMIT
        </button>
      </ModalFooter>
    </Modal>
  );
}
